import styled, { css } from 'styled-components';
import { palette } from './colors';
import { primaryColor } from '../../utils/helpers';
import defaultValidatorFn from "@emotion/is-prop-valid";

const Heading = styled.span.withConfig({
  shouldForwardProp: (prop) =>
    defaultValidatorFn(prop)
})`
    color: ${palette.graphite.heavyMetal};
    line-height: normal;
    padding: 0;
    margin: 0;
    font-weight: 700;

    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}

    ${(props) =>
        props.regular &&
        css`
            font-weight: 400 !important;
        `}

    ${(props) =>
        props.bold &&
        css`
            font-weight: 700 !important;
        `}

    ${(props) =>
        props.themed &&
        css`
            color: ${(props) => primaryColor(props)};
        `}
    ${(props) =>
        props.color &&
        css`
            color: ${(props) => props.color};
        `}
    ${(props) =>
        props.lighter &&
        css`
            opacity: 0.6;
        `}
    ${(props) =>
        props.margin &&
        css`
            margin: ${props.margin}px;
        `}
    ${(props) =>
        props.my &&
        css`
            margin-top: ${props.my}px;
            margin-bottom: ${props.my}px;
        `}
    ${(props) =>
        props.mx &&
        css`
            margin-left: ${props.mx}px;
            margin-right: ${props.mx}px;
        `}
    ${(props) =>
        props.mt &&
        css`
            margin-top: ${props.mt}px;
        `}
    ${(props) =>
        props.mr &&
        css`
            margin-right: ${props.mr}px;
        `}

    ${(props) =>
        props.mb &&
        css`
            margin-bottom: ${props.mb}px;
        `}
    ${(props) =>
        props.ml &&
        css`
            margin-left: ${props.ml}px;
        `}
    
    ${(props) =>
        props.link &&
        css`
            cursor: pointer;
        `}
    ${(props) =>
        props.maxWidth &&
        css`
            max-width: ${props.maxWidth}px;
        `}
    
    ${(props) =>
        props.mobileOnly &&
        css`
            display: none;
            @media (max-width: 992px) {
                display: initial;
            }
        `}
   ${(props) =>
        props.noWrap &&
        css`
            white-space: nowrap;
        `}
    
        // to be removed when headings are their respective proper h tags
   ${(props) =>
        props.displayBlock &&
        css`
            display: block;
        `}

    ${(props) =>
        props.extraBold &&
        css`
            font-weight: 800;
        `}
    ${(props) =>
        props.desktopOnly &&
        css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${(props) =>
        props.maxLineCount &&
        css`
            display: -webkit-box;
            -webkit-line-clamp: ${props.maxLineCount};
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
    ${(props) =>
        props.lineHeight &&
        css`
            line-height: ${props.lineHeight}!important;
        `}}

    ${(props) =>
            props.fontSizeRem &&
            css`
                font-size: ${props.fontSizeRem}rem!important;
            `}}
`;

// titles only
export const Heading1 = styled(Heading)`
    font-size: 24px;
`;

// card titles
export const Heading2 = styled(Heading)`
    font-size: 20px;
    font-weight: 800;
`;

// inside cards
export const Heading3 = styled(Heading)`
    font-size: 16px;
`;

// smallest heading
export const Heading4 = styled(Heading)`
    font-size: 14px;
`;
